import { createSelectionListViewComponent } from 'factories/SelectionListView'
import { getSessionItem, updateSessionItem } from 'helpers/sessionStorage'
import { getStorageKey } from '.'

export default createSelectionListViewComponent({
  pageTitleLanguageKey: 'status',
  allowInfiniteLoader: () => false,
  allowSearch: () => false,
  getValue: () => getSessionItem(getStorageKey(), {}).item?.serviceStatus,
  getOnChange: (self) => (each) =>
    updateSessionItem(getStorageKey(), {}, (draft) => {
      draft.item.serviceStatus = each.id
    }),
})()
